module.exports = __webpack_public_path__ + "img/compteur-de-vitesse.1e631558.png";